/* The loader in index.html stays up from the first frame until the first page is really ready: the app has
   drawn, and nothing on screen is still waiting (each page-level spinner, and Home's picture, hold it). Then it
   fades once. Never longer than 9 seconds. */
let holds = 0
let started = false
let gone = false
const el = () => document.getElementById('boot')

export const bootShowing = () => !gone && !!el()

function finish() {
  if (gone) return
  gone = true
  const b = el()
  if (!b) return
  b.classList.add('fade')
  setTimeout(() => b.remove(), 500)
}
let check: ReturnType<typeof setTimeout> | null = null
function maybe() {
  if (gone || !started || holds > 0) return
  if (check) clearTimeout(check)
  // a beat for anything that is about to show a spinner of its own
  check = setTimeout(() => { if (holds === 0) finish() }, 120)
}

/* Keep the loader up while something is loading. Returns the release. */
export function bootHold(): () => void {
  if (gone) return () => {}
  holds++
  let done = false
  return () => { if (done) return; done = true; holds--; maybe() }
}

/* The app has drawn its first page. */
export function bootStart() {
  if (started) return
  started = true
  maybe()
}
setTimeout(finish, 9000)
